import useRouter from 'hooks/use-router'
import PopUp from 'views/home/components/PopUp'

const SumaSix = () => {

  const { push } = useRouter()

  return (
    <div className='w-full'>
      <PopUp popUp={'suma-six'} setPopUpFalse={() => push('/home')} />
    </div>
  )
}

export default SumaSix
